export enum PersonType {
	MORALE = 'MORALE',
	PHYSIQUE = 'PHYSIQUE'
}
